import styled from "styled-components";

export const StyledHeader = styled.header`
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  border: none;
  outline: none;
  border-radius: 8px;
  padding: 20px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-left: 30px;
  }
  .navigation-desktop {
    display: none;
  }
  .navigation-desktop span.active {
    text-decoration: underline;
    font-weight: 700;
  }
  .logo {
    position: fixed;
    left: 30px;
    top: 30px;
    z-index: 9;
    //width: 15%;
    height: 30px;
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      //width: 5%;
    }
  }
  .logout-container {
    position: absolute;
    position: fixed;
    right: 30px;
    display: flex;
    align-items: center;
    font-size: 12px;
    background-color: ${({ theme }) => theme.colors.card};
    color: ${({ theme }) => theme.colors.text};
    border-radius: 50%;
  }

  .logout-icon {
    background-color: ${({ theme }) => theme.colors.card};
    height: 40px;
    width: 40px;
    border-radius: 50%;
    cursor: pointer;
    object-position: center;
    object-fit: cover;
    filter: brightness(1.3);
    border: 1px solid ${({ theme }) => theme.colors.text};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    min-width: max-content;
    .navigation-desktop {
      display: flex;
      gap: 62px;
      position: absolute;
      right: 120px;
      font-size: 14px;
      font-weight: 500;
      :hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 50px;
  right: 0;
  background-color: ${({ theme }) => theme.colors.card};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 170px;

  span {
    padding: 12px 16px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background-color: ${({ theme }) => theme.colors.background};
    }
  }
`;
